import { render, staticRenderFns } from "./DashboardKins.vue?vue&type=template&id=7be2b23a&"
import script from "./DashboardKins.vue?vue&type=script&lang=js&"
export * from "./DashboardKins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports